import { render } from "./WorkComponent.vue?vue&type=template&id=18981c51"
import script from "./WorkComponent.vue?vue&type=script&lang=js"
export * from "./WorkComponent.vue?vue&type=script&lang=js"

import "./WorkComponent.vue?vue&type=style&index=0&id=18981c51&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__